// Whether the reader has asked the system for less motion.
//
// Lifted out of FaqItem and BrandMark, which had grown identical copies, at the
// point a third and fourth caller were about to appear. It lives beside the
// reveal system rather than in either component because it belongs to none of
// them: it is the one question every animation on this site has to ask first.
//
// The `typeof` guard is not defensive padding. jsdom supplies no `matchMedia`,
// so every suite that renders an animating component would throw on the call
// rather than fail an assertion — and the answer for an environment that cannot
// express a motion preference is the same as for a reader who has not set one.
const prefersReducedMotion = () =>
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default prefersReducedMotion;
